var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWikiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6905813E-96C6-4A29-8B04-7056DEEC99CA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 24 24 24 24 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "43-wiki_document_search_result",
    transform: "translate(-1203.000000, -688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "most-popular",
    transform: "translate(1180.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(19.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_markedcalendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wiki-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "13.811996 13.6027844 14.6803514 8.8527 16.4913 8.8527 14.8839425 16.4283141 12.9908826 16.4283141 11.9751767 12.109033 10.9808422 16.4283141 9.09340634 16.4283141 7.4793 8.8527 9.29587264 8.8527 10.1653529 13.6027844 11.2058047 8.8527 12.7557968 8.8527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44309379,19.4815288 L18.3499178,19.4815288 L18.4381712,4.5154577 L5.54465665,4.5154577 L5.44309379,19.4815288 Z M4.00205929,21.0236249 L20.014672,21.0236249 L20.014672,2.97093692 L4,2.97093692 L4.00205929,21.0236249 Z",
    id: "Fill-2",
    fill: "#000000",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiIcon);
export default __webpack_public_path__ + "static/media/wiki-icon.c55bf9598fee9ca5282ea5bd9c7429f0.svg";
export { ForwardRef as ReactComponent };